import React from 'react';
import {getDate, getTime} from "../../../assets/js/date-time-converter";
import AnimateHeight from "react-animate-height";

class StartDateItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    handleItemClick = e => {
        e.preventDefault();
        this.setState({isOpen: !this.state.isOpen})
    }

    onCourseSelect = e => {
        const {courseId, sku} = this.props;
        this.props.handleCourseClick(e, sku, courseId);
        this.setState({isOpen: false})
    }

    render() {
        const {isOpen} = this.state;
        const meetingDatesHeight = isOpen ? 'auto' : 0;
        const {
            resourcedTexts,
            courseId,
            selectedCourseId,
            typeOfDay,
            startDateList,
            handleCourseClick,
        } = this.props;
        const isSelected = selectedCourseId === courseId;

        return (
            <div className='start-date__item'>
                <a href="#"
                   className={`${isSelected ? 'selected' : ''} ${isOpen ? 'is-open' : ''}`}
                   key={courseId}
                   onClick={this.handleItemClick}
                >
                    <div className="start-date__item-date">
                        {getDate(startDateList[0].startTime)}
                    </div>

                    {typeOfDay && (
                        <div className="start-date__item-type-of-day">
                            {typeOfDay}
                        </div>
                    )}
                </a>

                <AnimateHeight
                    duration={200}
                    height={meetingDatesHeight}
                >
                    <div className="start-date__item-meeting-dates">
                        <ol>
                            {startDateList.map((dateItem, i) => {
                                const {startTime, endTime, description, location} = dateItem;

                                return (
                                    <li key={i}>
                                        <div className="start-date__meeting-date">{getDate(startTime)}</div>
                                        <div className="start-date__meeting-time">
                                            {getTime(startTime)} -&nbsp;{getTime(endTime)}
                                        </div>
                                        <div className="start-date__meeting-location">{location}</div>
                                        <div className="start-date__meeting-description">{description}</div>
                                    </li>
                                )
                            })}
                            {(isSelected || handleCourseClick) && (
                                <li key="button" className="start-date__button-li">
                                    {isSelected ? (
                                        <button type="button" disabled>
                                            {resourcedTexts.moduleScheduleSelectedText}
                                        </button>
                                    ) : handleCourseClick && (
                                        <button
                                            type="button"
                                            onClick={this.onCourseSelect}
                                        >
                                            {resourcedTexts.moduleScheduleSelectText}
                                        </button>
                                    )}
                                </li>
                            )}
                        </ol>
                    </div>
                </AnimateHeight>
            </div>
        )
    }
}

export default StartDateItem;